// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__p7IO1","productName":"Table_productName__uMLYL"};